// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d662c90c","488":"d30e009b","732":"09b3024b"}[chunkId] + ".chunk.js";
};